export default "__VITE_ASSET__Ca8UN7MV__"